<template>
  <List :loading="loading" class="list">
    <ListItem v-for="d in data" :key="d.ID" @click.native="handleToContent(d)">
      <ListItemMeta :title="d.NEWSTITLE" :description="formatDate(d.NEWSDATETIME)" />
    </ListItem>
  </List>
</template>

<script>
import { GetNewsinfos } from '@api'
import { formatDate } from '@libs/util'
export default {
  name: 'news-mobile',
  data () {
    return {
      current: 1,
      pageSize: 99999,
      type: '',
      data: [],
      loading: false,
      formatDate
    }
  },
  mounted () {
    this.type = this.$route.query.type || '2'
    this.getPage()
  },
  methods: {
    async getPage () {
      this.loading = true
      try {
        const query = {
          PageIndex: this.current,
          PageSize: this.pageSize,
          SUPPLY_TYPE: this.type
        }
        const { data: { list } } = await GetNewsinfos(query)
        this.data = list
      } catch (e) {
        console.error(e)
      }
      this.loading = false
    },
    handleToContent ({ ID }) {
      const { type } = this
      this.$router.replace({
        name: 'content',
        query: {
          type,
          id: ID
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.list {
  width: 100%;
  height: 100%;
  overflow: auto;
  background: #fff;
  padding: 0 16px;
}
</style>
